import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  isFetching: false,
  error: null,
  discoveredEmail: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DISCOVER:
      return { ...state, isFetching: true, error: null, discoveredEmail: null };
    case types.DISCOVER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        discoveredEmail: action.payload.email || null,
      };
    case types.DISCOVER_ERROR:
      return {
        ...state,
        error: getErrorMessage(action.payload),
        isFetching: false,
      };
    case types.DISCOVER_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;
